import React, { useState, useEffect } from "react";
import Select from "react-select";
import { formatToZMW, rootUrl, sumOfArray } from "../../../helpers";
import { useOutletContext } from "react-router-dom";
import { useAuth } from "../../../context/auth-context";
import { FaList, FaSpinner, FaToggleOff, FaToggleOn } from "react-icons/fa";
import { BiCategory } from "react-icons/bi";

export default function Department({ startDate, endDate }) {

      const [allCash, setAllCash] = useState([]);
      const [filteredData, setFilteredData] = useState([]);
      const [openingBalance, setOpeningBalance] = useState(0);
      const [fromDate, setFromDate] = useState("");
      const [toDate, setToDate] = useState("");
      const [selectedCOA, setSelectedCOA] = useState(null); 
      const [showDetailedView, setShowDetailedView] = useState(true);
      const [selectedDept, setSelectedDept] = useState(null);
      const [selectedProgram, setSelectedProgram] = useState(null);
    
      const [loading, setLoading] = useState(true)
    
      const {allData, setAllData} = useOutletContext();
      const auth = useAuth();

      const displayTable = (data, bf) => {
        let totalCredits = 0;
        let totalDebits = 0;
        let balance = bf;
      
        // Group data by dept
        const groupedData = data.reduce((acc, obj) => {
          const dept = allData.budget.find((a) => a.id === obj.coa_id)?.dept || "Unknown";
          if (!acc[dept]) acc[dept] = [];
          acc[dept].push(obj);
          return acc;
        }, {});
      
        const rows = [];

      
        Object.keys(groupedData).forEach((coa) => {
          let coaDebits = 0;
          let coaCredits = 0;
      
          // Calculate COA totals
          groupedData[coa].forEach((obj) => {
            const debit = obj.type === "income" ? parseFloat(obj.amount) : 0;
            const credit = obj.type === "expense" ? parseFloat(obj.amount) : 0;
            coaDebits += debit;
            coaCredits += credit;
            totalCredits += credit;
            totalDebits += debit;
            balance += debit - credit;
          });
      
          if (showDetailedView) {
            // Detailed transactions
            groupedData[coa].sort((a,b)=> b.coa_id - a.coa_id).forEach((obj) => {
              const debit = obj.type === "income" ? parseFloat(obj.amount) : 0;
              const credit = obj.type === "expense" ? parseFloat(obj.amount) : 0;
              const trans = allData.budget.find((a) => a.id === obj.coa_id)
              rows.push(
                <tr key={obj.id} className="text-left">
                  {/* Transaction details */}
                  <td className="px-4 py-2 border-b border-gray-300 text-left">
                    {allData.dept.find(a=>a.id === trans?.dept)?.name}
                  </td>
                  <td className="px-4 py-2 border-b border-gray-300 text-left">{allData.program.find(a=>a.programCode === trans?.program)?.name}</td>
                  <td className="px-4 py-2 border-b border-gray-300 text-left">{allData.subProgram.find(a=>a.programCode === trans?.program && a.subProgramCode === trans?.subprogram)?.name}</td>
                  <td className="px-4 py-2 border-b border-gray-300 text-left">{trans?.coa}</td>
                  <td className="px-4 py-2 border-b border-gray-300 text-right">{formatToZMW(debit)}</td>
                  <td className="px-4 py-2 border-b border-gray-300 text-right">{formatToZMW(credit)}</td>
                  <td className="px-4 py-2 border-b border-gray-300 text-right">{formatToZMW(balance)}</td>
                </tr>
              );
            });
      
            // Subtotal row for detailed view
            rows.push(
              <tr key={`subtotal-${coa}`} className="bg-gray-100 ">
                <td className="px-4 py-2 border-b border-gray-300 font-bold text-center text-left" colSpan="4">
                  Subtotal for {allData.dept.find(a=>a.id ==coa)?.name}
                  
                </td>
                <td className="px-4 py-2 border-b border-gray-300 font-bold text-center text-right">{formatToZMW(coaDebits)}</td>
                <td className="px-4 py-2 border-b border-gray-300 font-bold text-center text-right">{formatToZMW(coaCredits)}</td>
                <td className="px-4 py-2 border-b border-gray-300 font-bold text-center text-right">{formatToZMW(balance)}</td>
              </tr>
            );
          } else {
            // Summary view row
            rows.push(
              <tr key={`summary-${coa}`} className="bg-gray-100">
                <td className="px-4 py-2 border-b border-gray-300 font-bold text-left" colSpan="4">
                  {allData.dept.find(a=>a.id === coa)?.name}
                </td>
                <td className="px-4 py-2 border-b border-gray-300 font-bold text-center text-right">{formatToZMW(coaDebits)}</td>
                <td className="px-4 py-2 border-b border-gray-300 font-bold text-center text-right">{formatToZMW(coaCredits)}</td>
                <td className="px-4 py-2 border-b border-gray-300 font-bold text-center text-right">
                  {formatToZMW(coaDebits - coaCredits)}
                </td>
              </tr>
            );
          }
        });
      
        // Total row
        const totals = (
          <tr className="bg-blue-950 text-white">
            <th className="px-4 py-2 border-b border-gray-300 text-left" colSpan="4">
              Total
            </th>
            <th className="px-4 py-2 border-b border-gray-300 text-center text-right">{formatToZMW(totalDebits)}</th>
            <th className="px-4 py-2 border-b border-gray-300 text-center text-right">{formatToZMW(totalCredits)}</th>
            <th className="px-4 py-2 border-b border-gray-300 text-center text-right">{formatToZMW(balance)}</th>
          </tr>
        );
      
        return (
          <>
            {rows}
            {totals}
          </>
        );
      };

      useEffect(() => {
        const fetchData = async () => {
          const response = await fetch(rootUrl(`/getCashByDate/${auth.user?.cid}~${startDate}~${endDate}`));
          const result = await response.json();
          const data = result.data || [];
    
          setAllCash(data.cash);
          const filtered = data.cash;
          setOpeningBalance(data.openingBalance);
          setFilteredData(filtered);
          setLoading(false)
        };
    
        if(startDate !== ""){
          fetchData();
        }
      }, [endDate]);

      // Filtering logic
      const handleFilter = () => {
        let filtered = allCash;
        if (selectedDept && selectedDept.value) {
          // Find all budget entries with the selected department
          const matchingBudget = allData.budget.filter(a => a.dept === selectedDept.value);
          const matchingIds = matchingBudget.map(a => a.id);
          filtered = filtered.filter((item) => matchingIds.includes(item.coa_id));
        }
        if (selectedProgram && selectedProgram.value) {
          // Find all budget entries with the selected program
          const matchingBudget = allData.budget.filter(a => a.program === selectedProgram.value);
          const matchingIds = matchingBudget.map(a => a.id);
          filtered = filtered.filter((item) => matchingIds.includes(item.coa_id));
        }
        setFilteredData(filtered);
      };

      const deptOptions = allData.dept?.map(dept => ({ value: dept.id, label: dept.name })) || [];
      const programOptions = allData.program?.map(prog => ({ value: prog.programCode, label: prog.name })) || [];
      return (
        <div className="w-full">
          <div className="flex w-full items-center justify-between border-b pb-4">
            <div className="flex flex-col">
              <h4 className="text-[20px] text-slate-800 font-bold flex items-center"> <BiCategory/> Department</h4>
            </div>
          </div>
    
          <div className="flex items-center space-x-4 my-4">
            <Select
              options={deptOptions}
              value={selectedDept}
              onChange={setSelectedDept}
              placeholder="Select Department"
              isClearable
              className="w-64"
            />
            <Select
              options={programOptions}
              value={selectedProgram}
              onChange={setSelectedProgram}
              placeholder="Select Program"
              isClearable
              className="w-64"
            />
            <button onClick={handleFilter} className="bg-blue-950 text-white px-4 py-2 rounded">
              Filter
            </button>
          </div>
    
          {
            loading?
            <div className='flex justify-center items-center h-full w-full text-blue-950 text-5xl p-5 m-5 '>
                <FaSpinner size={50} className="spinner"  />
            </div>
            :
            <>
             <div className="w-full gl-table table mt-5 text-[13px] rounded-b-md" title="Cash Book">
            <div id="heading">
              <span className="font-bold mb-5">
                {/* Opening balance: {formatToZMW(openingBalance)} */}
              </span>
            </div>
            <table className="table-auto w-full mt-4 border-collapse border border-gray-300 shadow-lg rounded-lg">
              <thead className="p-2">
                <tr className="bg-blue-950 text-white p-2">
                  <th className="px-4 py-2 border-b border-gray-300">Department</th>
                  <th className="px-4 py-2 border-b border-gray-300">Program</th>
                  <th className="px-4 py-2 border-b border-gray-300">Subprogram</th>
                  <th className="px-4 py-2 border-b border-gray-300">COA</th>
                  <th className="px-4 py-2 border-b border-gray-300">Debit</th>
                  <th className="px-4 py-2 border-b border-gray-300">Credit</th>
                  <th className="px-4 py-2 border-b border-gray-300">Balance</th>
                </tr>
              </thead>
              <tbody id="trows">{displayTable(filteredData, openingBalance)}</tbody>
            </table>
          </div></>
          }
        </div>
      );
}
